import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'app-flamingo-snackbar-loader',
    template: `
    <div style="display:flex;">
      <span>{{ data.message }}</span>
      <span style="flex-grow: 1"></span>
      <mat-progress-spinner mode="indeterminate" color="accent" diameter="18"></mat-progress-spinner>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FlamingoSnackBarLoaderComponent {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {

  }

}
